import { Checkmark20Filled, Delete20Filled } from '@fluentui/react-icons';
import styles from "./FilesList.module.css";
import { IColumn, DetailsList, SelectionMode, Spinner, SpinnerSize } from "@fluentui/react";

const FilesList = ({ files, onClear }: { files: any[], onClear: any }) => {
  const columns: IColumn[] = [
    { key: 'name', name: 'File Name', fieldName: 'name', minWidth: 300, maxWidth: 500 },
    { key: 'statusMessage', name: 'Status', fieldName: 'statusMessage', minWidth: 200, maxWidth: 300 },
    { key: 'action', name: '', fieldName: 'action', minWidth: 100, maxWidth: 100 }
  ];

  const renderIcon = (status: string, id: string) => {
    switch (status) {
      case 'uploading':
        return (
          <span className={styles.iconWrapper}>
            <Spinner size={SpinnerSize.small} />
          </span>
        );
      case 'success':
        return (
          <span className={styles.iconWrapper}>
            <Checkmark20Filled className={`${styles.fileListItemButton} ${styles.success}`} />
          </span>
        );
      case 'error':
      case 'pending':
        return (
          <span className={styles.iconWrapper}>
            <Delete20Filled className={`${styles.fileListItemButton} ${styles.delete}`} onClick={() => onClear(id)} />
          </span>
        );
      default:
        return null;
    }
  };

  const items = files.map((file) => ({
    key: file.id,
    name: file.file.name,
    statusMessage: file.statusMessage,
    action: renderIcon(file.status, file.id),
  }));

  return (
    <DetailsList
      className={styles.detailsList}
      items={items}
      columns={columns}
      selectionMode={SelectionMode.none}
    />
  );
};

export { FilesList };